import React, { useState } from 'react';
import { useTheme } from '../../../utils/theme-context';

type FAQItem = {
  title: string;
  answer: React.ReactNode;
};

const FAQ: FAQItem[] = [
  {
    title: 'What does Sofia do?',
    answer: (
      <p>
        Sofia answers staff questions about policies, regulations and standard
        operating procedures.
      </p>
    ),
  },
  {
    title: 'How does Sofia work?',
    answer: (
      <>
        <p className="mb-2">
          Your sign-in with Sofia is synced with Microsoft, so as long as you are
          logged into your MS account, you’ll be able to access Sofia’s chat
          stream. You hold your own profile there, so your question history is
          personal to you.
        </p>
        <p>
          Just ask any questions you need the answer to related to the Club’s
          operations and she’ll give you the answer. She’ll give you access to
          the full document as well in case you need it.
        </p>
      </>
    ),
  },
  {
    title: 'What are some examples of questions Sofia will answer?',
    answer: (
      <ul className="list-disc pl-5 space-y-1">
        <li>What time does the front desk open on Monday?</li>
        <li>Is the Oasis open at 8am?</li>
        <li>What colour nail polish can I wear on shift?</li>
        <li>If I go on a holiday, do I still receive my share of tips?</li>
      </ul>
    ),
  },
  {
    title: 'What can’t Sofia answer?',
    answer: (
      <p>
        She’s currently not connected to HR systems so she can’t give you
        information on things like your own shift pattern, pay or the status of
        your holiday.
      </p>
    ),
  },
];

const Faqs: React.FC = () => {
  const { theme } = useTheme();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="bg-gray-100 dark:bg-black rounded-3xl p-5">
      <div className="w-full text-black font-medium text-base flex flex-row items-center py-2 mb-2">
        <img
          src={theme === 'dark' ? '/svg/icons/faqs-white.svg' : '/svg/icons/faqs.svg'}
          className="mr-2 object-contain w-[20px]"
          alt="faqs"
        />
        <span className="dark:text-primary-darkMode">Frequently asked questions</span>
      </div>

      {FAQ.map((faq, index) => {
        const isOpen = openIndex === index;

        return (
          <div
            key={index + faq.title}
            className="w-full bg-white dark:bg-bgColor-darkMode rounded-lg mt-1 mb-2"
          >
            <button
              type="button"
              onClick={() => handleToggle(index)}
              className="w-full p-3 flex flex-row items-center justify-between text-left font-normal text-base text-gray-900 dark:text-primary-darkMode"
            >
              <div className="flex flex-row items-center">
                <span className="font-semibold text-base mr-2">Q.</span>
                <span>{faq.title}</span>
              </div>
              <span
                className={`ml-2 text-gray-500 dark:text-gray-400 transform transition-transform duration-200 ${
                  isOpen ? 'rotate-45' : ''
                }`}
              >
                +
              </span>
            </button>

            {/* Smoothly animated content */}

			{isOpen &&  <div
              className={`grid transition-all duration-300 ease-out ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <div className={`overflow-hidden px-3 pb-3 text-sm leading-relaxed text-[#202020] dark:text-gray-300 border-t border-gray-100 dark:border-gray-700 pt-2`}>
                {faq.answer}
              </div>
            </div> }
           
          </div>
        );
      })}
    </div>
  );
};

export default Faqs;
